import React from 'react';
import styles from './Card.module.css';
import './Chart.css'
import logo from '../../assets/images/logo.svg';
import CanvasJSReact from '../../lib/canvasjs.react';

export default function Card() {

    var CanvasJSChart = CanvasJSReact.CanvasJSChart;

    const options = {

        axisY:{
            gridColor : 'white',
            tickLength: 0,
            lineThickness:0,
            margin:0,
            valueFormatString:" "
        },

        axisX:{
            tickLength: 0,
            lineThickness:0,
            margin:0,
            valueFormatString:" ",
            labelFontColor : "hsl(28, 10%, 53%)",
            labelFontSize : "15",
            labelFontWeight : "bold"
        },

        dataPointMaxWidth : 48,
       
        title: {
            text: ""
        },

        data: [
        {
            color: "hsl(10, 79%, 65%)",
            type: "column",
            dataPoints:     [
                {label: "mon",y: 17.45},
                {label: "tue",y: 34.91},
                {label: "wed",y: 52.36},
                {label: "thu",y: 31.07,  color : 'hsl(186, 34%, 60%)'},
                {label: "fri",y: 23.39},
                {label: "sat",y: 43.28},
                {label: "sun",y: 25.48}]
        }
        ],

        toolTip : {
            fontColor : "#FFFFFF",
            fontWeight : "bolder",
            backgroundColor : "hsl(25, 47%, 15%)",
            borderColor : "hsl(25, 47%, 15%)",
            cornerRadius : "4",
            content : "${y}"
        },
    }


  return (
    <div className={styles.card}>
        <header>
            <div className={styles.balance}>
                <h1>My balance</h1>
                <span className={styles.balanceNumber}>$921.48</span>
            </div>

            <img src={logo} alt="logo"/>
        </header>

        <article>
            <h2>Spending - last 7 days</h2>
            <CanvasJSChart 
            options={options} 
            containerProps={{
                height: '13rem'
            }}
            />
            <hr />
            <div className={styles.footerCard}>
                <div className={styles.month}>
                    <p>Total this month</p>
                    <span className={styles.balanceMonth}>$478.33</span>
                </div>

                <div className={styles.lastMonth}>
                    <div className={styles.balanceEvolution}>+2.4%</div>
                    <p>from last month</p>
                </div>
            </div>

        </article>
    </div>
  )
}
